/**
 * Date Range Filter Component
 * Date range picker with healthcare-appropriate constraints
 */

import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import { setFilters } from '../../../store/dashboardSlice';

const { RangePicker } = DatePicker;

interface DateRangeFilterProps {
  className?: string;
}

function DateRangeFilter({ className }: DateRangeFilterProps) {
  const dispatch = useAppDispatch();
  const dateRange = useAppSelector(state => state.dashboard.filters.dateRange);

  const handleDateRangeChange = (dates: [Dayjs | null, Dayjs | null] | null) => {
    if (dates && dates[0] && dates[1]) {
      dispatch(setFilters({
        dateRange: {
          start: dates[0].toISOString(),
          end: dates[1].toISOString(),
        }
      }));
    }
  };

  const today = dayjs();
  
  return (
    <div className={`filter ${className || ''}`} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label htmlFor="date-range-picker">Date Range:</label>
      <RangePicker
        id="date-range-picker"
        value={[dayjs(dateRange.start), dayjs(dateRange.end)]}
        onChange={handleDateRangeChange}
        format="MM/DD/YYYY"
        disabledDate={(current) => {
          // Disable future dates - healthcare data is historical
          return current && current > today.endOf('day');
        }}
        placeholder={['Start Date', 'End Date']}
        style={{ width: '280px' }}
      />
    </div>
  );
}

export default DateRangeFilter;